import { apiClient } from '@/config/axios';

interface SettingsResponse {
  logo: string;
  mainColor: string;
  secondaryColor: string;
  bgColor: string;
}

export async function fetchSettings(): Promise<SettingsResponse> {
  const { data } = await apiClient.get<SettingsResponse>('/api/v2/settings');
  return {
    logo: data.logo,
    mainColor: data.mainColor,
    secondaryColor: data.secondaryColor,
    bgColor: data.bgColor,
  };
}
